"use client";

import { VerificationCodeInput } from "@/component/VerificationCodeInput";
import { CloseOutlined } from "@ant-design/icons";

interface VerificationCodeViewProps {
  email: string;
  isLoading: boolean;
  error: string;
  onCodeSubmit: (code: string) => void;
  onResendCode: () => Promise<void>;
  onClose: () => void;
}

export function VerificationCodeView({
  email,
  isLoading,
  error,
  onCodeSubmit,
  onResendCode,
  onClose,
}: VerificationCodeViewProps) {
  return (
    <div className="relative w-[447px] min-h-[286px] sm:w-[480px] sm:rounded-[28px] sm:bg-background-card py-10 min-w-[360px]">
      {/* 关闭按钮 */}
      <CloseOutlined
        className="absolute text-white! top-5 right-5 w-6 h-6 flex items-center justify-center bg-transparent border-none cursor-pointer opacity-70"
        onClick={onClose}
      />
      <h2 className="text-2xl font-bold text-text-primary text-center mb-8">
        Check your email to continue
      </h2>
      <VerificationCodeInput
        email={email}
        isVerifying={isLoading}
        hasError={!!error}
        onVerify={onCodeSubmit}
        onResend={onResendCode}
        resendCooldown={60}
      />
    </div>
  );
}
